import { UseAccountUsageResponse } from 'api/BillingApi';
import { MetricProject } from 'modules/domains/billing';
import { createContext, useContext } from 'react';

export type ProjectQueryContextState = {
  isError: boolean;
  isLoading: boolean;
  projects: Record<string, MetricProject>;
  projectUsageMetrics: UseAccountUsageResponse['values'];
};

const defaultState = {
  isError: false,
  isLoading: false,
  projects: {},
  projectUsageMetrics: {},
};

export const ProjectQueryContext = createContext<ProjectQueryContextState>(defaultState);

export const useProjectQueryContext = () => {
  const context = useContext(ProjectQueryContext);

  if (!context) {
    throw new Error('useProjectQueryContext must be used within ProjectQueryContextProvider');
  }

  return context;
};
